import type { ColumnDef } from '@tanstack/react-table'

export type TableAny = any

export const defaultColumnOptions = <T extends object>(): Partial<ColumnDef<T>> => ({
  cell: info => info.getValue(),
})
